exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content {\n  background-color: #ffffff;\n  border: 1px solid #d9d9d9;\n  padding: 40px;\n  box-shadow: 0 0 5px 2px rgba(200, 200, 200, 0.5);\n  -webkit-box-shadow: 0 0 5px 2px rgba(200, 200, 200, 0.5);\n  -moz-box-shadow: 0 0 5px 2px rgba(200, 200, 200, 0.5);\n  -o-box-shadow: 0 0 5px 2px rgba(200, 200, 200, 0.5); }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./node_modules/@mprep/shared/lib/angular/components/default-screen/default-screen.scss
// module id = sIAG
// module chunks = 3